<template>
  <div id="devicePosition" style="width: 100vw; height: 87vh; position: relative">
<!--    <div class="splitScreen">-->
<!--      <span>分屏量</span>-->
<!--      <el-select v-model="spilt" @change="spiltChange">-->
<!--        <el-option v-for="item in spiltOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--      </el-select>-->
<!--    </div>-->
    <div class="flex width100 background-white" style="height: 6vh; margin-bottom: 5px; display: none">
      <div style="width: 16%">
        <div class="flex row-center">
          <el-image style="height: 6vh" :src="companyLogo" alt="加载失败" />
        </div>
      </div>
      <div style="width: 68%">{{ companyName }}</div>
      <div class="flex row-around" style="width: 16%">
        <el-badge :value="isPlaying3 > 999 ? 999 : isPlaying3" :hidden="!isPlaying3">
          <i class="el-icon-message-solid" style="color: yellow" :class="{ rotate: isPlaying3 }" @click="openAlarmTable(3)" />
        </el-badge>
        <el-badge :value="isPlaying2 > 999 ? 999 : isPlaying2" :hidden="!isPlaying2">
          <i class="el-icon-message-solid" style="color: orange" :class="{ rotate: isPlaying2 }" @click="openAlarmTable(2)" />
        </el-badge>
        <el-badge :value="isPlaying1 > 999 ? 999 : isPlaying1" :hidden="!isPlaying1">
          <i class="el-icon-message-solid" style="color: red" :class="{ rotate: isPlaying1 }" @click="openAlarmTable(1)" />
        </el-badge>
      </div>
    </div>
    <el-container v-loading="loading" style="height: 85vh; margin-top: 21px" element-loading-text="拼命加载中">
      <div class="p-rela">
        <el-aside :width="collapse ? '0' : '300px'" style="background-color: #ffffff; height: 85vh">
          <DeviceTree :clickShipEvent="clickShipEvent" :clickEvent="clickEvent" :clickPlayBackEvent="openPlayBack" :contextMenuEvent="contextMenuEvent"></DeviceTree>
        </el-aside>
        <div class="collapse-icon" @click="resizeCamaer">
          <div class="collapse-arrows">></div>
        </div>
      </div>
      <el-main style="height: 85vh;overflow-y: hidden">
        <!--   <el-header height="5vh" style="text-align: left;font-size: 17px;line-height:5vh">
          分屏:
          <i class="el-icon-full-screen btn" :class="{active:spilt==1}" @click="spilt=1"/>
          <i class="el-icon-menu btn" :class="{active:spilt==4}" @click="spilt=4"/>
          <i class="el-icon-s-grid btn" :class="{active:spilt==9}" @click="spilt=9"/>
        </el-header>-->
<!--        <el-main style="padding: 0">
          <div class="flex flex-wrap width100" style="height: 85vh; background-color: #000">
            <div v-for="i in spilt" :key="i" class="play-box" :style="liveStyle" :class="{ redborder: playerIdx == i - 1 }" @click="changePlayer(i)">
              <div style="position: relative; width: 100%; height: 100%" class="height100 flex row-center">
                <div v-show="!videoUrl[i - 1]" style="width: 100%; background-color: #000000; color: #ffffff; font-size: 30px; font-weight: bold; z-index: 10">{{ i }}</div>
                &lt;!&ndash;                <player ref="player" v-if="videoUrl[i-1]" :videoUrl="videoUrl[i-1]" fluent autoplay @screenshot="shot"&ndash;&gt;
                &lt;!&ndash;                        @destroy="destroy" @setPlayUrl="setPlayUrl(null,i-1)"/>&ndash;&gt;
                <LivePlayer aspect="fullscreen" :videoUrl="videoUrl[i - 1]" v-loading="videoLoading[i - 1]" element-loading-background="#000" fluent autoplay live stretch :controls="!videoLoading[i - 1]" hide-stretch-button hide-big-play-button></LivePlayer>
                <span @click="closeVideo(videoUrl[i - 1], i - 1)" class="videoClose" v-if="videoUrl[i - 1]">关闭</span>
              </div>
            </div>
          </div>
        </el-main>-->
        <div ref="dzBox" id="videoBox" style="width:100%;height:100%;">
          <LoadCamaer
            v-if="dzWidth && dzHeight"
            ref="loadCamaer"
            :video-platform-id="'playWnd'"
            :video-parent-id="'videoBox'"
            :layout="'3x3'"
            :point-code="pointCode"
            :render-params="renderParams"
            :video-width="dzWidth"
            :video-height="dzHeight"
            :show-buttons="true"
            :page-name="'portVideo_1'"
            @clickCamera="(data) => handleClickCamera(data)"
            @initFailed="handleInitFailed"
          />
        </div>
      </el-main>
      <div style="width: 300px;height:85vh;">
        <div class="flex row-center background-white p-rela" style="height: 12vh">
          <el-image
            style="width: 100%; height: 100%"
            src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fi5.yemet.com%2Fupload%2Ffeed_img%2F5fa00b3e71c0ed732715674282aa312c659ed63c.gif&refer=http%3A%2F%2Fi5.yemet.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658299675&t=b8f316711b6c0cdd63c4d92aea24c9e0"
            fit="contain"
          ></el-image>
          <div class="p-abso" style="color: white">今日船舶报警{{ todayCount }}次</div>
        </div>
        <div style="height: 15vh">
          <div style="background-color: #ffff65; height: 33.3333%; border-radius: 10px; cursor: pointer; margin-top: 5px; display: flex; justify-content: space-between; align-items: center; padding: 0 20px; color: #2c7ad6; user-select: none" @click="openAlarmTable(1)">
            <el-row type="flex" style="align-items: center">
              <div style="height: 4vh; width: 4vh">
                <svg t="1686211744151" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1566">
                  <path
                    d="M541.696 830.976H107.008V175.104h567.296v209.408c0 12.288 9.216 23.552 22.528 27.136h0.512c19.968 5.632 39.936-8.192 39.936-27.136V146.432c0-15.872-14.336-28.672-31.744-28.672H75.264c-17.408 0-31.744 12.8-31.744 28.672v713.216c0 15.872 14.336 28.672 31.744 28.672h453.632c31.232 0 45.568-35.328 21.504-53.76l-1.024-1.024c-2.048-1.536-5.12-2.56-7.68-2.56z"
                    p-id="1567"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M192.512 519.168c0 5.12 4.096 9.216 9.216 9.216h200.192c5.12 0 9.216-4.096 9.216-9.216V407.552c0-29.696-11.776-57.344-31.744-77.312-20.992-20.992-48.64-31.744-77.312-31.744-29.696 0-57.344 11.776-77.312 31.744-20.992 20.992-31.744 48.64-31.744 77.312v111.104l-0.512 0.512z m24.064-110.592c0-47.104 38.4-85.504 85.504-85.504s85.504 38.4 85.504 85.504v95.232H216.576V408.576zM315.392 248.832c0-5.12-4.096-9.216-9.216-9.216s-9.216 4.096-9.216 9.216v24.576h18.944v-24.576h-0.512zM422.912 311.808l18.944-18.944c3.584-3.584 3.584-9.216 0-13.824-3.584-3.584-9.216-3.584-13.824 0L409.6 297.984l13.312 13.824zM189.952 315.392l13.824-13.824-18.944-18.944c-3.584-3.584-9.216-3.584-13.824 0-3.584 3.584-3.584 9.216 0 13.824l18.944 18.944z"
                    p-id="1568"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M328.704 406.528h-38.4l16.384-33.792c2.048-5.12 0-10.24-4.096-12.8-4.096-3.072-10.24 0-12.8 4.096L266.24 411.136c-1.536 3.072-1.536 6.656 0.512 9.216 1.536 3.072 5.12 4.096 8.192 4.096h36.352l-22.528 35.328c-3.072 4.096-1.536 10.24 3.072 12.8 1.536 0.512 3.584 1.536 5.12 1.536 3.072 0 6.656-1.536 8.192-4.096l31.232-49.664c2.048-3.072 2.048-6.656 0-9.216-1.536-3.584-5.12-4.608-7.68-4.608z"
                    p-id="1569"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M363.008 601.6H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h114.688c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 601.6c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1570"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M394.752 674.816H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h146.432c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 674.816c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1571"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M449.024 748.032h-199.68c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h200.192c8.704 0 15.36-6.656 15.36-15.36-0.512-8.704-7.168-15.36-15.872-15.36zM203.264 748.032c-8.704 0-15.36 6.656-15.36 15.36v0.512c0 8.192 6.656 15.36 15.36 15.36h0.512c8.192 0 15.36-6.656 15.36-15.36v-0.512c-1.024-8.704-7.68-15.36-15.872-15.36zM731.136 568.32c-49.152 0-89.088 39.936-89.088 89.088 0 49.152 39.936 89.088 89.088 89.088s89.088-39.936 89.088-89.088-39.936-89.088-89.088-89.088z m3.072 136.704c-24.576 0-44.544-19.968-44.544-44.544s19.968-44.544 44.544-44.544 44.544 19.968 44.544 44.544c0 24.576-19.968 44.544-44.544 44.544z m241.152-91.648c-3.584-17.92-14.848-29.184-29.696-29.184h-2.048c-28.16 0-51.2-22.528-51.2-50.688 0-7.168 3.072-16.384 4.608-19.456 7.168-16.384 1.024-35.84-13.824-45.568l-59.904-32.768c-14.848-6.144-32.256-2.56-43.52 8.704-7.68 7.68-27.136 23.552-40.96 23.552s-33.792-15.872-40.96-23.552c-11.264-11.264-28.672-14.848-43.52-9.216l-1.024 0.512-60.928 33.28-1.536 1.024c-14.336 9.728-19.456 28.672-12.8 44.544 0.512 1.024 4.608 10.752 4.608 19.456 0 28.16-23.04 50.688-51.2 50.688h-2.56c-14.336 0-26.112 11.264-29.184 29.184-3.072 15.36-4.608 31.232-5.12 47.104 0 19.968 4.608 44.544 5.12 47.104 3.584 17.92 14.848 29.184 29.696 29.184h2.048c28.16 0 51.2 23.04 51.2 50.688 0 7.168-3.072 16.384-4.608 19.456-7.168 16.384-1.024 35.84 13.824 45.568l58.88 32.256c15.36 6.144 32.768 2.56 44.032-9.216 7.168-7.68 27.648-25.088 41.984-25.088s34.304 16.896 41.984 25.6c11.776 12.288 30.208 15.872 45.568 8.704l59.392-32.768 1.536-1.024c14.336-9.728 19.456-28.672 12.8-44.544-2.56-6.144-4.096-12.8-4.608-19.456 0-28.16 23.04-50.688 51.2-50.688h2.56c14.336 0 26.112-11.264 29.184-29.184 0-0.512 5.12-26.112 5.12-47.104-1.024-19.456-5.632-44.032-6.144-47.104z m-45.056 78.336c-48.64 6.144-84.48 47.616-84.48 96.256 0 11.264 3.072 22.016 5.12 29.184l-42.496 23.552c-5.632-5.632-11.264-10.24-17.408-15.36-18.944-13.824-36.864-20.992-54.272-20.992-16.896 0-35.328 7.168-53.76 20.48-6.144 4.608-11.776 9.216-17.408 14.848l-40.96-23.04c2.56-7.168 5.12-18.432 5.12-29.696 0-49.152-36.352-90.112-84.48-96.768-1.536-10.24-2.56-20.48-3.072-31.232 0-10.24 1.536-23.04 3.072-31.232 48.64-6.144 84.48-47.616 84.48-96.768 0-11.264-2.56-22.016-5.12-29.184l44.032-24.064c3.584 3.584 9.728 9.216 17.408 14.336 18.432 13.312 36.352 19.968 53.248 19.968 16.384 0 34.304-6.656 52.736-19.456 7.68-5.12 13.824-10.752 17.408-13.824l41.984 23.552c-3.072 9.728-5.12 19.456-5.12 29.696 0 49.152 36.864 90.112 84.48 96.256 1.024 8.192 3.072 20.992 3.072 31.232-1.024 11.264-2.56 24.064-3.584 32.256z"
                    p-id="1572"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
              <div>一级预警</div>
            </el-row>
            <div>{{ isPlaying1 > 999 ? 999 + '+' : isPlaying1 }}</div>
          </div>
          <div style="background-color: #f3b14e; height: 33.3333%; border-radius: 10px; cursor: pointer; margin-top: 5px; display: flex; justify-content: space-between; align-items: center; padding: 0 20px; color: #fff; user-select: none" @click="openAlarmTable(2)">
            <el-row type="flex" style="align-items: center">
              <div style="height: 4vh; width: 4vh">
                <svg t="1686211744151" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1566">
                  <path
                    d="M541.696 830.976H107.008V175.104h567.296v209.408c0 12.288 9.216 23.552 22.528 27.136h0.512c19.968 5.632 39.936-8.192 39.936-27.136V146.432c0-15.872-14.336-28.672-31.744-28.672H75.264c-17.408 0-31.744 12.8-31.744 28.672v713.216c0 15.872 14.336 28.672 31.744 28.672h453.632c31.232 0 45.568-35.328 21.504-53.76l-1.024-1.024c-2.048-1.536-5.12-2.56-7.68-2.56z"
                    p-id="1567"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M192.512 519.168c0 5.12 4.096 9.216 9.216 9.216h200.192c5.12 0 9.216-4.096 9.216-9.216V407.552c0-29.696-11.776-57.344-31.744-77.312-20.992-20.992-48.64-31.744-77.312-31.744-29.696 0-57.344 11.776-77.312 31.744-20.992 20.992-31.744 48.64-31.744 77.312v111.104l-0.512 0.512z m24.064-110.592c0-47.104 38.4-85.504 85.504-85.504s85.504 38.4 85.504 85.504v95.232H216.576V408.576zM315.392 248.832c0-5.12-4.096-9.216-9.216-9.216s-9.216 4.096-9.216 9.216v24.576h18.944v-24.576h-0.512zM422.912 311.808l18.944-18.944c3.584-3.584 3.584-9.216 0-13.824-3.584-3.584-9.216-3.584-13.824 0L409.6 297.984l13.312 13.824zM189.952 315.392l13.824-13.824-18.944-18.944c-3.584-3.584-9.216-3.584-13.824 0-3.584 3.584-3.584 9.216 0 13.824l18.944 18.944z"
                    p-id="1568"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M328.704 406.528h-38.4l16.384-33.792c2.048-5.12 0-10.24-4.096-12.8-4.096-3.072-10.24 0-12.8 4.096L266.24 411.136c-1.536 3.072-1.536 6.656 0.512 9.216 1.536 3.072 5.12 4.096 8.192 4.096h36.352l-22.528 35.328c-3.072 4.096-1.536 10.24 3.072 12.8 1.536 0.512 3.584 1.536 5.12 1.536 3.072 0 6.656-1.536 8.192-4.096l31.232-49.664c2.048-3.072 2.048-6.656 0-9.216-1.536-3.584-5.12-4.608-7.68-4.608z"
                    p-id="1569"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M363.008 601.6H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h114.688c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 601.6c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1570"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M394.752 674.816H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h146.432c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 674.816c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1571"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M449.024 748.032h-199.68c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h200.192c8.704 0 15.36-6.656 15.36-15.36-0.512-8.704-7.168-15.36-15.872-15.36zM203.264 748.032c-8.704 0-15.36 6.656-15.36 15.36v0.512c0 8.192 6.656 15.36 15.36 15.36h0.512c8.192 0 15.36-6.656 15.36-15.36v-0.512c-1.024-8.704-7.68-15.36-15.872-15.36zM731.136 568.32c-49.152 0-89.088 39.936-89.088 89.088 0 49.152 39.936 89.088 89.088 89.088s89.088-39.936 89.088-89.088-39.936-89.088-89.088-89.088z m3.072 136.704c-24.576 0-44.544-19.968-44.544-44.544s19.968-44.544 44.544-44.544 44.544 19.968 44.544 44.544c0 24.576-19.968 44.544-44.544 44.544z m241.152-91.648c-3.584-17.92-14.848-29.184-29.696-29.184h-2.048c-28.16 0-51.2-22.528-51.2-50.688 0-7.168 3.072-16.384 4.608-19.456 7.168-16.384 1.024-35.84-13.824-45.568l-59.904-32.768c-14.848-6.144-32.256-2.56-43.52 8.704-7.68 7.68-27.136 23.552-40.96 23.552s-33.792-15.872-40.96-23.552c-11.264-11.264-28.672-14.848-43.52-9.216l-1.024 0.512-60.928 33.28-1.536 1.024c-14.336 9.728-19.456 28.672-12.8 44.544 0.512 1.024 4.608 10.752 4.608 19.456 0 28.16-23.04 50.688-51.2 50.688h-2.56c-14.336 0-26.112 11.264-29.184 29.184-3.072 15.36-4.608 31.232-5.12 47.104 0 19.968 4.608 44.544 5.12 47.104 3.584 17.92 14.848 29.184 29.696 29.184h2.048c28.16 0 51.2 23.04 51.2 50.688 0 7.168-3.072 16.384-4.608 19.456-7.168 16.384-1.024 35.84 13.824 45.568l58.88 32.256c15.36 6.144 32.768 2.56 44.032-9.216 7.168-7.68 27.648-25.088 41.984-25.088s34.304 16.896 41.984 25.6c11.776 12.288 30.208 15.872 45.568 8.704l59.392-32.768 1.536-1.024c14.336-9.728 19.456-28.672 12.8-44.544-2.56-6.144-4.096-12.8-4.608-19.456 0-28.16 23.04-50.688 51.2-50.688h2.56c14.336 0 26.112-11.264 29.184-29.184 0-0.512 5.12-26.112 5.12-47.104-1.024-19.456-5.632-44.032-6.144-47.104z m-45.056 78.336c-48.64 6.144-84.48 47.616-84.48 96.256 0 11.264 3.072 22.016 5.12 29.184l-42.496 23.552c-5.632-5.632-11.264-10.24-17.408-15.36-18.944-13.824-36.864-20.992-54.272-20.992-16.896 0-35.328 7.168-53.76 20.48-6.144 4.608-11.776 9.216-17.408 14.848l-40.96-23.04c2.56-7.168 5.12-18.432 5.12-29.696 0-49.152-36.352-90.112-84.48-96.768-1.536-10.24-2.56-20.48-3.072-31.232 0-10.24 1.536-23.04 3.072-31.232 48.64-6.144 84.48-47.616 84.48-96.768 0-11.264-2.56-22.016-5.12-29.184l44.032-24.064c3.584 3.584 9.728 9.216 17.408 14.336 18.432 13.312 36.352 19.968 53.248 19.968 16.384 0 34.304-6.656 52.736-19.456 7.68-5.12 13.824-10.752 17.408-13.824l41.984 23.552c-3.072 9.728-5.12 19.456-5.12 29.696 0 49.152 36.864 90.112 84.48 96.256 1.024 8.192 3.072 20.992 3.072 31.232-1.024 11.264-2.56 24.064-3.584 32.256z"
                    p-id="1572"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
              <div>二级预警</div>
            </el-row>
            <div>{{ isPlaying2 > 999 ? 999 + '+' : isPlaying2 }}</div>
          </div>
          <div style="background-color: #ec4739; height: 33.3333%; border-radius: 10px; cursor: pointer; margin-top: 5px; display: flex; justify-content: space-between; align-items: center; padding: 0 20px; color: #fff; user-select: none" @click="openAlarmTable(3)">
            <el-row type="flex" style="align-items: center">
              <div style="height: 4vh; width: 4vh">
                <svg t="1686211744151" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1566">
                  <path
                    d="M541.696 830.976H107.008V175.104h567.296v209.408c0 12.288 9.216 23.552 22.528 27.136h0.512c19.968 5.632 39.936-8.192 39.936-27.136V146.432c0-15.872-14.336-28.672-31.744-28.672H75.264c-17.408 0-31.744 12.8-31.744 28.672v713.216c0 15.872 14.336 28.672 31.744 28.672h453.632c31.232 0 45.568-35.328 21.504-53.76l-1.024-1.024c-2.048-1.536-5.12-2.56-7.68-2.56z"
                    p-id="1567"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M192.512 519.168c0 5.12 4.096 9.216 9.216 9.216h200.192c5.12 0 9.216-4.096 9.216-9.216V407.552c0-29.696-11.776-57.344-31.744-77.312-20.992-20.992-48.64-31.744-77.312-31.744-29.696 0-57.344 11.776-77.312 31.744-20.992 20.992-31.744 48.64-31.744 77.312v111.104l-0.512 0.512z m24.064-110.592c0-47.104 38.4-85.504 85.504-85.504s85.504 38.4 85.504 85.504v95.232H216.576V408.576zM315.392 248.832c0-5.12-4.096-9.216-9.216-9.216s-9.216 4.096-9.216 9.216v24.576h18.944v-24.576h-0.512zM422.912 311.808l18.944-18.944c3.584-3.584 3.584-9.216 0-13.824-3.584-3.584-9.216-3.584-13.824 0L409.6 297.984l13.312 13.824zM189.952 315.392l13.824-13.824-18.944-18.944c-3.584-3.584-9.216-3.584-13.824 0-3.584 3.584-3.584 9.216 0 13.824l18.944 18.944z"
                    p-id="1568"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M328.704 406.528h-38.4l16.384-33.792c2.048-5.12 0-10.24-4.096-12.8-4.096-3.072-10.24 0-12.8 4.096L266.24 411.136c-1.536 3.072-1.536 6.656 0.512 9.216 1.536 3.072 5.12 4.096 8.192 4.096h36.352l-22.528 35.328c-3.072 4.096-1.536 10.24 3.072 12.8 1.536 0.512 3.584 1.536 5.12 1.536 3.072 0 6.656-1.536 8.192-4.096l31.232-49.664c2.048-3.072 2.048-6.656 0-9.216-1.536-3.584-5.12-4.608-7.68-4.608z"
                    p-id="1569"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M363.008 601.6H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h114.688c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 601.6c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1570"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M394.752 674.816H248.32c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h146.432c8.704 0 15.36-6.656 15.36-15.36 0-8.192-6.656-15.36-15.36-15.36zM202.752 674.816c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36 15.36-6.656 15.36-15.36c0-8.192-6.656-15.36-15.36-15.36z"
                    p-id="1571"
                    fill="#8a8a8a"
                  ></path>
                  <path
                    d="M449.024 748.032h-199.68c-8.704 0-15.36 6.656-15.36 15.36s6.656 15.36 15.36 15.36h200.192c8.704 0 15.36-6.656 15.36-15.36-0.512-8.704-7.168-15.36-15.872-15.36zM203.264 748.032c-8.704 0-15.36 6.656-15.36 15.36v0.512c0 8.192 6.656 15.36 15.36 15.36h0.512c8.192 0 15.36-6.656 15.36-15.36v-0.512c-1.024-8.704-7.68-15.36-15.872-15.36zM731.136 568.32c-49.152 0-89.088 39.936-89.088 89.088 0 49.152 39.936 89.088 89.088 89.088s89.088-39.936 89.088-89.088-39.936-89.088-89.088-89.088z m3.072 136.704c-24.576 0-44.544-19.968-44.544-44.544s19.968-44.544 44.544-44.544 44.544 19.968 44.544 44.544c0 24.576-19.968 44.544-44.544 44.544z m241.152-91.648c-3.584-17.92-14.848-29.184-29.696-29.184h-2.048c-28.16 0-51.2-22.528-51.2-50.688 0-7.168 3.072-16.384 4.608-19.456 7.168-16.384 1.024-35.84-13.824-45.568l-59.904-32.768c-14.848-6.144-32.256-2.56-43.52 8.704-7.68 7.68-27.136 23.552-40.96 23.552s-33.792-15.872-40.96-23.552c-11.264-11.264-28.672-14.848-43.52-9.216l-1.024 0.512-60.928 33.28-1.536 1.024c-14.336 9.728-19.456 28.672-12.8 44.544 0.512 1.024 4.608 10.752 4.608 19.456 0 28.16-23.04 50.688-51.2 50.688h-2.56c-14.336 0-26.112 11.264-29.184 29.184-3.072 15.36-4.608 31.232-5.12 47.104 0 19.968 4.608 44.544 5.12 47.104 3.584 17.92 14.848 29.184 29.696 29.184h2.048c28.16 0 51.2 23.04 51.2 50.688 0 7.168-3.072 16.384-4.608 19.456-7.168 16.384-1.024 35.84 13.824 45.568l58.88 32.256c15.36 6.144 32.768 2.56 44.032-9.216 7.168-7.68 27.648-25.088 41.984-25.088s34.304 16.896 41.984 25.6c11.776 12.288 30.208 15.872 45.568 8.704l59.392-32.768 1.536-1.024c14.336-9.728 19.456-28.672 12.8-44.544-2.56-6.144-4.096-12.8-4.608-19.456 0-28.16 23.04-50.688 51.2-50.688h2.56c14.336 0 26.112-11.264 29.184-29.184 0-0.512 5.12-26.112 5.12-47.104-1.024-19.456-5.632-44.032-6.144-47.104z m-45.056 78.336c-48.64 6.144-84.48 47.616-84.48 96.256 0 11.264 3.072 22.016 5.12 29.184l-42.496 23.552c-5.632-5.632-11.264-10.24-17.408-15.36-18.944-13.824-36.864-20.992-54.272-20.992-16.896 0-35.328 7.168-53.76 20.48-6.144 4.608-11.776 9.216-17.408 14.848l-40.96-23.04c2.56-7.168 5.12-18.432 5.12-29.696 0-49.152-36.352-90.112-84.48-96.768-1.536-10.24-2.56-20.48-3.072-31.232 0-10.24 1.536-23.04 3.072-31.232 48.64-6.144 84.48-47.616 84.48-96.768 0-11.264-2.56-22.016-5.12-29.184l44.032-24.064c3.584 3.584 9.728 9.216 17.408 14.336 18.432 13.312 36.352 19.968 53.248 19.968 16.384 0 34.304-6.656 52.736-19.456 7.68-5.12 13.824-10.752 17.408-13.824l41.984 23.552c-3.072 9.728-5.12 19.456-5.12 29.696 0 49.152 36.864 90.112 84.48 96.256 1.024 8.192 3.072 20.992 3.072 31.232-1.024 11.264-2.56 24.064-3.584 32.256z"
                    p-id="1572"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
              <div>三级预警</div>
            </el-row>
            <div>{{ isPlaying3 > 999 ? 999 + '+' : isPlaying3 }}</div>
          </div>
        </div>
        <div class="background-white flex-col row-between" style="margin-top: 15px; height: 55.9vh">
          <el-table ref="tableDataRealtime" :data="alarmList" @cell-mouse-enter="onHoverTable" @cell-mouse-leave="onLeaveTable" height="100%">
            <el-table-column class="el-table-bg" label="报警详情" width="220px">
              <template slot-scope="{ row }">
                <div class="flex-col row-between" style="height: 80px">
                  <div>{{ row.warningContent }}</div>
                  <div>{{ new Date(row.warningTime).format('yyyy-MM-dd') }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="80px">
              <template slot-scope="{ row }">
                <span :style="row.warningState == 0 ? 'color: red' : ''">{{ row.warningState == 0 ? '未处理' : '已处理' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <!--          <el-pagination
            @size-change="handleSizeChange"
            @current-change="currentChange"
            :current-page="currentPage"
            :page-size="count"
            :page-sizes="[15, 25, 35, 50]"
            layout="total, sizes, prev, pager, next"
            :total="total">
          </el-pagination>-->
        </div>
        <div class="background-white flex row-center" style="margin-bottom: 5px; height: 4vh; cursor: pointer; display: none">
          <el-button style="width: 100%" @click="openAlarmTable()">历史报警数据</el-button>
        </div>
        <div class="flex-col row-center background-white" style="height: 7vh; color: deepskyblue; display: none">
          <span>重庆市力合智控技术有限公司</span>
          <span>荣誉出品</span>
        </div>
      </div>
    </el-container>
    <alarmTable ref="alarmTable"></alarmTable>
    <devicePlayer ref="devicePlayer" v-loading="isLoging"></devicePlayer>
    <shipDataTable ref="shipDataTable"></shipDataTable>
    <div v-if="showTips" class="tips">
      <span class="spantitle">检测到你还未安装视频插件,请下载安装后重启浏览器.</span>
      <span class="spanbtn" @click.stop="handleLoadPlugin">下载</span>
      <span class="spanbtn" @click.stop="cancelShowTips">否</span>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config.js'
import devicePlayer from './dialog/RecordPlayerBack'
import uiHeader from '../layout/UiHeader.vue'
import player from './common/jessibuca.vue'
import DeviceTree from './common/DeviceTree.vue'
import alarmTable from './dialog/alarmTable.vue'
import shipDataTable from './dialog/shipDataTable.vue'
import LivePlayer from '@liveqing/liveplayer'
import moment from 'moment'
import LoadCamaer from "./common/LoadCamaer.vue";

export default {
  name: 'live',
  components: {
    LoadCamaer,
    uiHeader,
    player,
    DeviceTree,
    alarmTable,
    LivePlayer,
    devicePlayer,
    shipDataTable
  },
  data() {
    return {
      videoUrl: [],
      shipName:'',
      spilt: 9, //分屏
      spiltOptions: [
        {
          value: 9,
          lable: '9'
        },
        {
          value: 16,
          lable: '16'
        },
        {
          value: 25,
          lable: '25'
        }
      ],
      playerIdx: 0, //激活播放器
      showPlayerIdx: 0, //激活播放器的样式
      updateLooper: 0, //数据刷新轮训标志
      currentPage: 1,
      count: 10,
      total: 10,

      //channel
      loading: false,
      isLoging: false,
      videoLoading: [false, false, false, false, false, false, false, false, false],
      isPlaying1: 0,
      isPlaying2: 0,
      isPlaying3: 0,
      todayCount: 0,
      collapse: false,
      alarmList: [],
      carouselTimer: null,
      companyLogo: '',
      companyName: '',
      timing: null,
      dzWidth: null,
      dzHeight: null,
      pointCode: [],
      renderParams: {
        showToolBar: 1, // 是否显示工具栏，0-不显示，非0-显示
        showSmart: 0, // 是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        streamMode: 0, // 主子码流标识：0-主码流，1-子码流
        transMode: 1, // 传输协议：0-UDP，1-TCP
        gpuMode: 1, // 是否启用GPU硬解，0-不启用，1-启用
        wndId: -1, // 播放窗口序号（在2x2以上布局下可指定播放窗口）
      },
      currentWndId: 1,
      showTips: false,
    }
  },
  activated() {
    if (this.videoUrl.length > 0) {
      for (let index in videoPlay2) {
        // 重新拉流
        let stringList = videoPlay2[index].split('/')
        let length = stringList.length
        let device_channel = stringList[length - 1].split('.')[0]
        let deviceId = device_channel.split('_')[0]
        let channel = device_channel.split('_')[1]
        this.activatedSendDevicePush(deviceId, channel, index)
      }
    }
  },
  mounted() {
    //每分钟更新报警信息
    this.timing = setInterval(this.getAlarm, 8000)
    this.handleResize()
    this.synchronizationVideo()
    window.addEventListener('message',event=>{
      sessionStorage.removeItem("isActive")
      if(event.data.type == 'resize'){
          sessionStorage.setItem("isActive",event.data.isActive)
          this.handleResize();
      }else if(event.data.type == 'login'){
        this.resetSetItem("shipName",event.data.shipName)
      }
    })
  },
  created() {
    this.companyLogo = config.API_ROOT + '/' + JSON.parse(sessionStorage.getItem('userCompany')).companyLogoPath
    this.companyName = JSON.parse(sessionStorage.getItem('userCompany')).companyName
    this.shipName = sessionStorage.getItem("shipName")
    this.checkPlayByParam()
    this.getAlarm()
    this.$nextTick(() => {
      this.onLeaveTable()
    })
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  computed: {
    liveStyle() {
      let style = { width: '100%', height: '100%' }
      switch (this.spilt) {
        case 4:
          style = { width: '49.6%', height: '49%' }
          break
        case 9:
          style = { width: '33%', height: '32%' }
          break
        case 16:
          style = { width: '24.7%', height: '24%' }
          break
        case 25:
          style = { width: '19.7%', height: '19%' }
          break
      }
      this.$nextTick(() => {
        for (let i = 0; i < this.spilt; i++) {
          const player = this.$refs.player
          player && player[i] && player[i].updatePlayerDomSize()
        }
      })
      return style
    }
  },
  watch: {
    $route(to, from) {
      // 离开画面
      if (from.path === '/live') {
        this.dzWidth = this.dzHeight = 0
        this.$refs.loadCamaer.closeWindow()
      }
      // 进入画面
      if (to.path === '/live') {
        this.handleResize()
      }
    },
    spilt(newValue) {
      let that = this
      for (let i = 1; i <= newValue; i++) {
        if (!that.$refs['player' + i]) {
          continue
        }
        this.$nextTick(() => {
          if (that.$refs['player' + i] instanceof Array) {
            that.$refs['player' + i][0].resize()
          } else {
            that.$refs['player' + i].resize()
          }
        })
      }
      window.localStorage.setItem('split', newValue)
    },
    '$route.fullPath': 'checkPlayByParam'
  },
  destroyed() {
    clearTimeout(this.updateLooper)
  },
  methods: {
    handleResize () {
      let _this = this
      this.$nextTick(() => {
        setTimeout(function () {
          _this.dzWidth = _this.$refs.dzBox.offsetWidth
          _this.dzHeight = _this.$refs.dzBox.offsetHeight
          let dzLeft = _this.$refs.dzBox.offsetLeft
          let dzTop = _this.$refs.dzBox.offsetTop
          _this.$nextTick(()=>{
            _this.$refs.loadCamaer.resizeFresh(_this.dzWidth, _this.dzHeight,dzLeft,dzTop,false)
          })
        },1000)
      })
    },
    resizeCamaer() {
      this.collapse = !this.collapse;
      this.$nextTick(() => {
        this.dzWidth = this.$refs.dzBox.offsetWidth
        this.dzHeight = this.$refs.dzBox.offsetHeight
        let dzLeft = this.$refs.dzBox.offsetLeft
        let dzTop = this.$refs.dzBox.offsetTop
        this.$refs.loadCamaer.resizeFresh(this.dzWidth, this.dzHeight,dzLeft,dzTop,true)
      })
    },
    synchronizationVideo () {
      this.$axios({ method: 'post', url: `/api/EqlayerVideo/controlPTZ`,
        params: {
          url:"/api/resource/v2/camera/search",
          body: JSON.stringify({pageNo:1,pageSize:1000})
        } })
    },
    spiltChange() {
      this.videoLoading = []
      if (this.videoUrl.length > 0) {
        this.videoUrl.forEach((item, index) => {
          if (this.spilt < index + 1) {
            this.$set(this.videoUrl, index, '')
          }
        })
      }
      for (let i = 0; i < this.spilt; i++) {
        this.videoLoading.push(false)
      }
    },
    clickShipEvent(row) {
      this.$refs.loadCamaer.hidenWindow()
      //  打开弹框
      this.$refs.shipDataTable.openDialog(row)
    },
    openPlayBack(row) {
      this.$refs.loadCamaer.hidenWindow()
      var format = moment().format('yyyy-MM-DD')
      let deviceId = row.deviceId
      let channelId = row.channelId
      this.$refs.devicePlayer.openDialog('record', row.cameraIndexCode, { date: format })
    },
    closeVideo(url, index) {
      this.$set(this.videoUrl, index, '')
      // 不能断流,万一别人在看,就会断流
      // if(url==null || url.length==0){return}
      // let that = this;
      // let stringList = url.split('/');
      // let length = stringList.length;
      // let device_channel = stringList[length-1].split(".")[0];
      // let deviceId = device_channel.split("_")[0];
      // let channel = device_channel.split("_")[1];
      // this.$axios({
      //   method: 'get',
      //   url: '/api/play/stop/' + deviceId + "/" + channel
      // }).then(function (res) {
      //   // 成功关闭
      //   // that.videoUrl[index] = null
      //   that.$set(that.videoUrl, index, '')
      // }).catch(function (error) {
      //   if (error.response.status === 402) { // 已经停止过
      //     that.$set(that.videoUrl, index, '')
      //   } else {
      //     console.log(error)
      //   }
      // });
    },
    destroy(idx) {
      this.clear(idx.substring(idx.length - 1))
    },
    clickEvent: function (data) {
      // 点击某一个节点
      if (data.type == 'ship') {
        for (let item of data.children) {
          this.currentWndId = parseInt(item.cameraIndex)
          this.pointCode[this.currentWndId - 1] = item.cameraIndexCode
          if(sessionStorage.getItem("outSizeLogin") && sessionStorage.getItem("outSizeLogin")==1){
            this.$nextTick(()=>{
              this.$refs.loadCamaer.reStartPreviewSeven(item.cameraIndexCode, this.currentWndId)
            })
          }else{
            this.$refs.loadCamaer.reStartPreviewSeven(item.cameraIndexCode, this.currentWndId)

          }

          // if (item.channelId && item.deviceId) {
          //   this.sendDevicePush2(item, item.cameraIndex - 1)
          // }
        }
      } else {
        // if (data.channelId && data.deviceId) {
        //   this.sendDevicePush(data)
        // }
        const code = data.cameraIndexCode
        this.pointCode[this.currentWndId - 1] = code
        if(sessionStorage.getItem("outSizeLogin") && sessionStorage.getItem("outSizeLogin")==1){
          this.$nextTick(()=>{
            this.$refs.loadCamaer.reStartPreviewSeven(code, this.currentWndId)
          })
        }else{
          this.$refs.loadCamaer.reStartPreviewSeven(code, this.currentWndId)

        }

      }
    },
    contextMenuEvent: function (data) {},
    changePlayer(i) {
      this.playerIdx = i - 1
      if (i !== 1 && i !== 2 && i !== 4 && i !== 5) {
        this.showPlayerIdx = i - 1
      } else {
        if (i === 1 || i === 2) {
          this.showPlayerIdx = 12
        } else {
          this.showPlayerIdx = 45
        }
      }
    },
    //通知设备上传媒体流
    sendDevicePush: function (itemData) {
      // if (itemData.status === 0) {
      //   this.$message.error('设备离线!');
      //   return
      // }
      this.save(itemData)
      let deviceId = itemData.deviceId
      // this.isLoging = true;
      let channelId = itemData.channelId
      console.log('通知设备推流1：' + deviceId + ' : ' + channelId)
      let idxTmp = this.playerIdx
      let that = this
      this.$set(this.videoLoading, idxTmp, true)
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId
      })
        .then(function (res) {
          if (res.data.code == 0 && res.data.data) {
            itemData.playUrl = res.data.data.httpsFlv
            let playurl = res.data.data.ws_flv
            if (window.location.protocol == 'https:') {
              playurl = playurl.replace('ws://111.10.228.138:6080', 'wss://api.lhmovie.com')
            }
            that.setPlayUrl(playurl, idxTmp)
          } else {
            that.$message.error(res.data.msg)
          }
        })
        .catch(function (e) {})
        .finally(() => {
          that.$set(this.videoLoading, idxTmp, false)
        })
    },
    sendDevicePush2: function (itemData, idx) {
      // if (itemData.status === 0) {
      //   this.$message.error('设备离线!');
      //   return
      // }
      this.save(itemData)
      let deviceId = itemData.deviceId
      // this.isLoging = true;
      let channelId = itemData.channelId
      console.log('通知设备推流1：' + deviceId + ' : ' + channelId)
      let idxTmp = idx
      let that = this
      this.$set(this.videoLoading, idxTmp, true)
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId
      })
        .then(function (res) {
          if (res.data.code == 0 && res.data.data) {
            itemData.playUrl = res.data.data.httpsFlv
            let playurl = res.data.data.ws_flv
            if (window.location.protocol == 'https:') {
              playurl = playurl.replace('ws://111.10.228.138:6080', 'wss://api.lhmovie.com')
            }
            that.setPlayUrl(playurl, idxTmp)
          } else {
            that.$message.error(res.data.msg)
          }
        })
        .catch(function (e) {})
        .finally(() => {
          setTimeout(() => {
            that.$set(this.videoLoading, idxTmp, false)
          }, 1000)
        })
    },
    activatedSendDevicePush: function (deviceId, channelId, idx) {
      console.log('通知设备推流1：' + deviceId + ' : ' + channelId)
      this.$set(this.videoUrl, idx, '')
      let idxTmp = idx
      let that = this
      this.$set(this.videoLoading, idxTmp, true)
      this.$axios({
        method: 'get',
        url: '/api/play/start/' + deviceId + '/' + channelId
      })
        .then(function (res) {
          if (res.data.code == 0 && res.data.data) {
            that.setPlayUrl(res.data.data.flv, idxTmp)
          } else {
            that.$message.error(res.data.msg)
          }
        })
        .catch(function (e) {})
        .finally(() => {
          setTimeout(() => {
            that.$set(this.videoLoading, idxTmp, false)
          }, 1000)
        })
    },
    setPlayUrl(url, idx) {
      this.$set(this.videoUrl, idx, url)
      let _this = this
      setTimeout(() => {
        window.localStorage.setItem('videoUrl', JSON.stringify(_this.videoUrl))
      }, 100)
    },
    checkPlayByParam() {
      let { deviceId, channelId } = this.$route.query
      if (deviceId && channelId) {
        this.sendDevicePush({ deviceId, channelId })
      }
    },
    shot(e) {
      // console.log(e)
      // send({code:'image',data:e})
      var base64ToBlob = function (code) {
        let parts = code.split(';base64,')
        let contentType = parts[0].split(':')[1]
        let raw = window.atob(parts[1])
        let rawLength = raw.length
        let uInt8Array = new Uint8Array(rawLength)
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        return new Blob([uInt8Array], {
          type: contentType
        })
      }
      let aLink = document.createElement('a')
      let blob = base64ToBlob(e) //new Blob([content]);
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true) //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = '截图'
      aLink.href = URL.createObjectURL(blob)
      aLink.click()
    },
    getAlarm() {
      this.getTodayAlarmCount()
      this.getAlarmCount(1)
      this.getAlarmCount(2)
      this.getAlarmCount(3)
      this.getAlarmList()
    },
    getAlarmCount(level) {
      let that = this
      this.$axios({
        method: 'get',
        url: `/api/warningLog/list`,
        params: {
          warningLev: level,
          warningState: '0',
          page: this.currentPage,
          count: this.count
        }
      })
        .then(function (res) {
          if (level === 1) {
            that.isPlaying1 = res.data.data.total
          } else if (level === 2) {
            that.isPlaying2 = res.data.data.total
          } else if (level === 3) {
            that.isPlaying3 = res.data.data.total
          }
        })
        .catch(function (error) {
          console.log(error)
          that.loading = false
        })
    },
    getTodayAlarmCount() {
      let that = this
      this.$axios({ method: 'get', url: `/api/warningLog/nowDayWarningCount` })
        .then(function (res) {
          that.todayCount = res.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getAlarmList() {
      let that = this
      this.$axios({
        method: 'get',
        url: `/api/warningLog/list`,
        params: {
          page: this.currentPage,
          count: this.count
        }
      })
        .then(function (res) {
          that.total = res.data.data.total
          that.alarmList = res.data.data.list
          that.loading = false
          if (callback) callback()
        })
        .catch(function (error) {
          that.loading = false
        })
    },
    currentChange: function (val) {
      this.currentPage = val
      this.getAlarmList()
    },
    handleSizeChange: function (val) {
      this.count = val
      this.getAlarmList()
    },
    onHoverTable() {
      //鼠标移入清除定时器（暂停轮播）
      clearInterval(this.carouselTimer)
    },
    onLeaveTable() {
      //鼠标移出继续执行轮播
      const table = this.$refs.tableDataRealtime
      const bodyTable = table.bodyWrapper
      // console.log(table, bodyTable)
      bodyTable.style.overflow = 'hidden'
      this.carouselTimer = setInterval(() => {
        bodyTable.scrollTop += 1
        // console.log(bodyTable.scrollTop)
        if (bodyTable.clientHeight + bodyTable.scrollTop >= bodyTable.scrollHeight) {
          // 重置table距离顶部距离
          bodyTable.scrollTop = 0
        }
      }, 100)
    },
    openAlarmTable(level) {
      this.$refs.loadCamaer.hidenWindow()
      if (level === 1) {
        this.isPlaying1 = 0
      } else if (level === 2) {
        this.isPlaying2 = 0
      } else if (level === 3) {
        this.isPlaying3 = 0
      }
      this.$refs.alarmTable.openDialog(level, this.getUserList)
      this.getAlarm()
    },
    save(item) {
      let dataStr = window.localStorage.getItem('playData') || '[]'
      let data = JSON.parse(dataStr)
      data[this.playerIdx] = item
      window.localStorage.setItem('playData', JSON.stringify(data))
    },
    clear(idx) {
      let dataStr = window.localStorage.getItem('playData') || '[]'
      let data = JSON.parse(dataStr)
      data[idx - 1] = null
      window.localStorage.setItem('playData', JSON.stringify(data))
    },
    // 点击对应的摄像头
    handleClickCamera (data) {
      const type = data.responseMsg.type
      const code = data.responseMsg.msg.cameraIndexCode
      const winId = data.responseMsg.msg.wndId
      if (this.warningFlag) {
        this.warningFlag = !this.warningFlag
        this.operationInfo = ''
      }
      if (type === 1) {
        // 选中
        this.selectedCameraCode = code
        this.currentWndId = winId
        this.$nextTick(() => {
          if (this.currentTaskTab === 'preset') {
            this.presetName = ''
            this.optionsValue = 1
            this.initOptions()
            this.handleRequestOptions()
          } else if (this.currentTaskTab === 'scan') {
            this.scanOptionsValue = 1
            this.initScanOptions()
            this.requestScanOptions()
          }
        })
      }
      if (type === 2 && winId === 1) {
        this.selectedCameraCode = code
      }
    },
    // 下载插件
    handleLoadPlugin() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = './static/video/VideoWebPlugin.exe'
      link.setAttribute('download', 'VideoWebPlugin.exe')
      document.body.appendChild(link)
      link.click()
    },
    // 关闭插件窗口
    cancelShowTips() {
      this.showTips = false
    },
    // 打开插件窗口
    handleInitFailed() {
      this.showTips = true
    },
  }
}
</script>
<style scoped>
@charset "utf-8";

.tips {
  position: fixed;
  background-color: rgb(255, 238, 138);
  color: #2a2a2a;
  text-align: center;
  width: 600px;
  top: 70px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 40px;
  .spantitle {
    display: inline-block;
    line-height: 40px;
  }
  .spanbtn {
    display: inline-block;
    padding: 4px 10px;
    border: 1px solid #e2e2e2;
    margin: auto 10px;
    border-radius: 2px;
    cursor: pointer;
  }
  .spanbtn:hover {
    border-color: #1890ff;
  }
}

:deep(.el-main) {
  padding: 0 10px;
}
.btn {
  margin: 0 10px;
}

.btn:hover {
  color: #409eff;
}

.btn.active {
  color: #409eff;
}

.redborder {
  border: 1px solid red !important;
}

.splitScreen {
  position: absolute;
  top: -2px;
  left: 310px;
}
.splitScreen >>> .el-select .el-input__inner {
  width: 50px;
  height: 21px;
  padding: 0 0 0 10px;
  line-height: 21px;
  border-color: #000000;
}
.splitScreen >>> .el-select .el-input__icon {
  line-height: 21px;
  color: #000000;
}

.splitScreen >>> .el-select .el-input__suffix {
  right: 0;
}

/*.redborder:nth-child(1) {*/
/*  border-right: none !important;*/
/*}*/

/*.redborder:nth-child(2) {*/
/*  border-left: none !important;*/
/*}*/

/*.redborder:nth-child(4) {*/
/*  border-right: none !important;*/
/*}*/

/*.redborder:nth-child(5) {*/
/*  border-left: none !important;*/
/*}*/

.play-box {
  background-color: #000000;
  border: 1px solid #505050;
}

.play-box >>> .video-js .vjs-control {
  width: 3em !important;
}

/*.play-box:nth-child(1) {*/
/*  border-right: none;*/
/*}*/

/*.play-box:nth-child(2) {*/
/*  border-left: none;*/
/*}*/

/*.play-box:nth-child(4) {*/
/*  border-right: none;*/
/*}*/

/*.play-box:nth-child(5) {*/
/*  border-left: none;*/
/*}*/

.logo-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.logo-box img {
  width: 40px;
  height: 40px;
}
.logo-box h1 {
  font-size: 18px;
}

.el-icon-message-solid {
  font-size: xxx-large;
}

::v-deep.el-badge__content.is-fixed {
  top: 10px;
}

.collapse-icon {
  width: 25px;
  height: 35px;
  border-radius: 50%;
  position: absolute;
  right: -12px;
  top: 40%;
  /*border: 1px solid #f6ba86;*/
  background: #f6cf6e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  clip: rect(0px, 25px, 40px, 14px);
}

.collapse-arrows {
  line-height: 0;
  margin-left: 8px;
  height: 10%;
  font-size: x-large;
  color: #cd9919;
}

.rotate {
  display: block;
  animation: rotate 0.5s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  25% {
    transform: rotateZ(20deg);
  }
  50% {
    transform: rotateZ(0deg);
  }
  75% {
    transform: rotateZ(-20deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}
</style>
<style scoped>
.el-loading-parent--relative {
  position: unset !important;
}
.videoList {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.video-item {
  position: relative;
  width: 15rem;
  height: 10rem;
  margin-right: 1rem;
  background-color: #000000;
}

.video-item-img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}

.video-item-img:after {
  content: '';
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 3rem;
  height: 3rem;
  background-image: url('../assets/loading.png');
  background-size: cover;
  background-color: #000000;
}

.video-item-title {
  position: absolute;
  bottom: 0;
  color: #000000;
  background-color: #ffffff;
  line-height: 1.5rem;
  padding: 0.3rem;
  width: 14.4rem;
}

.baidumap {
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 去除百度地图版权那行字 和 百度logo */
.baidumap > .BMap_cpyCtrl {
  display: none !important;
}

.baidumap > .anchorBL {
  display: none !important;
}
.videoClose {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 2px 10px;
  background-color: #000000;
  opacity: 0.4;
  border-radius: 20%;
  color: #ffffff;
  text-align: center;
  line-height: 1.5rem;
  font-size: 10px;
  cursor: pointer;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/live.vue